"use client"
import React, { useEffect } from 'react';
import {useToast} from "@/contexts/ToastProvider";

// Recursively extract error messages and push them into the accumulator array
const collectErrors = (errors: any, accumulator: React.ReactNode[]) => {
    Object.keys(errors).forEach(key => {
        const error = errors[key];
        if (typeof error === 'string' || (error?.message && typeof error.message === 'string')) {
            accumulator.push(<li key={key}>{error.message || error}</li>);
        } else if (typeof error === 'object') {
            collectErrors(error, accumulator);
        }
    });
};

const useFormErrorToast = (errors: any) => {  // Changed FieldErrors to any for generalization

    const toast = useToast();

    useEffect(() => {
        if (Object.keys(errors).length) {
            const flatErrors: React.ReactNode[] = [];
            collectErrors(errors, flatErrors);
            toast.error(<ul>{flatErrors}</ul>);
        }
    }, [errors, toast]);
};

export default useFormErrorToast;
